export default "## CodePreviewer\n\n在线预览和演示你的组件和代码，通过 code 传递自己的代码，通过 showCode 设置是否展示代码，默认：true。\n"